module.exports = __webpack_public_path__ + "assets/img/carousel-2-640.4b741425.webp";